import styled from "styled-components";

import { ResetPasswordPageStyle } from "@pages/resetPasswordPage/resetPasswordPageStyle";

export const SetPasswordPageStyle = styled(ResetPasswordPageStyle)`

`;
